export default __webpack_public_path__ + "static/media/top_demo_image_club_match_result.c335f0b0.png";